import {
  Component, OnInit, ElementRef, ViewChild, AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, NgZone,
} from '@angular/core';
import { Subject, Observable, Subscription, timer } from "rxjs";
import { eventEmitterService } from "../../../service/eventEmitter.service";
import { FeedService } from '../../../service/feed.service';
import { GroupService } from "../../../service/group.service";
import { environment } from "../../../../environments/environment";
import { Router } from "@angular/router";
import { filter } from 'lodash';

@Component({
  selector: 'app-allgroups',
  templateUrl: './allgroups.component.html',
  styleUrls: ['./allgroups.component.css']
})
export class AllgroupsComponent implements OnInit {
  onlineNewMsgGroups = [];
  allOnlineGroups = [];
  onlineGroupLists = [];
  onlineGroups = [];
  buildingsFilterGroupsLists = [];
  buildingsFilterGroups = [];
  totalMsg = 0;
  socketId;
  userId;
  currentTimeStamp = '?ver=' + Date.now();
  activeUser;
  leavingGroupId='';
  leavingGroupRef='';
  leavingGroupName='';
  apiUrl = environment.apiUrl;
  s3apiUrl = environment.s3BucketApi;
  private timer;
  private sub: Subscription;
  private totalCount = { getAllMsgCount : 0 , getAllGroupMsgCount : 0 , getAllGroupsCount : 0 };
  newMessageNoResult = false;
  responseMsg;

  constructor(
    private eventService : eventEmitterService,
    private _changeDetector: ChangeDetectorRef,
    private _groupService : GroupService,
    private ngZone:NgZone,
    private router:Router,
    private _feed: FeedService,
  ) { }

  ngOnInit() {

    this.timer = timer(200,8000);
    // subscribing to a observable returns a subscription object
    this.sub = this.timer.subscribe(t => { this._groupService.getAllResidentsGroups(); // Changed from defaultGroupInfo
       if(this.onlineGroups){
          this.sub.unsubscribe();
       }
      this.currentTimeStamp = '?ver=' + Date.now();
    });

    this._feed._feed$.subscribe((feedsRes) => {
        let group = feedsRes['gr'];
        if(group) {
          this.onlineGroups = this.onlineGroups.filter(g=>g.id !== group.id)
        }

    })

    //If user click New Message button from Allgroups page,
    //it will redirect to My Groups page with new message user search section
    this.eventService.eventEmit$
        .subscribe(newGroup => {
            if(newGroup.newMsg){
              if(newGroup.actionPage == "/allgroups" || newGroup.actionPage == "allgroups"){
                this.router.navigate(['groups'],{queryParams : {open: 'newmsg'}});
              }
            }

            //Listening building filter values from message header component event emition
            if(newGroup.filterBuilding){
              this.resetFilterBuilding(newGroup.filterBuilding);
            }
        });

    this.eventService._msgCount$
    .subscribe(event => {
            //console.log("All Count", event);
            this.totalCount.getAllMsgCount = event['getAllMsgCount'];
            this.totalCount.getAllGroupMsgCount = event['getAllGroupMsgCount'];
     });

    //Subscribed all sockets emition groups results based on current logged in user's
    this._groupService.group$
        .subscribe(message => {
            /*
            *  Get all groups based on current logged in user's building(s)
            */
            if(message["allresidentsgroups"]){
                var groupId = message["allresidentsgroups"].id;

                /* If groups already present in online groups list array,
                *  Only replaced last message with unreadMsg count value if group user is not in online
                */

                if(this.onlineGroupLists.indexOf(groupId) > -1){
                    //Update Read Status to connected users
                    this.onlineGroups.forEach(function callback(group, index, array) {
                        group.totalUnReadMsg = message["allresidentsgroups"].totalUnReadMsg;
                        group.lastMessage = message["allresidentsgroups"].lastMessage;
                        if(message["createdGroup"]){
                            if(group.id == message["createdGroup"].id){
                                group.image = message["createdGroup"].image;
                            }
                        }
                    });

                    //Get all groups list based on building filtered values
                    if(message["buildingsFilter"] === true){
                        this.buildingsFilterGroupsLists.push(groupId);
                        this.buildingsFilterGroups.push(message["allresidentsgroups"]);
                        this.buildingsFilterGroupsLists = this.buildingsFilterGroupsLists.filter((v, i, a) => a.indexOf(v) === i);
                        this.buildingsFilterGroups = this.buildingsFilterGroups.filter((v, i, a) => i === a.findIndex((t) => (t.id === v.id )));
                        //this.buildingsFilterGroups = this.buildingsFilterGroups.filter((v, i, a) => i === a.findIndex( (list) => ( list.id  == removedUserId )));
                        this.onlineGroups = this.buildingsFilterGroups;
                    }

                }else{
                    //When page load initially push all groups in following array
                    this.onlineGroupLists.push(groupId);
                    this.onlineGroups.push(message["allresidentsgroups"]);
                }

                //Re-arranged the group list array based on recent group value.
                this.onlineGroups.sort(
                (a, b) => {
                    var currentLMCD = isNaN(Date.parse(a.createdAt)) ? 0 : Date.parse(a.createdAt);
                    var nextLMCD =  isNaN(Date.parse(b.createdAt)) ? 0 : Date.parse(b.createdAt);
                    if(currentLMCD > nextLMCD) {
                    return -1;
                    }
                    if(currentLMCD < nextLMCD) {
                    return 1;
                    }
                });
                this.totalCount.getAllGroupsCount = this.onlineGroups.length;
                this.eventService._msgCount$.next(this.totalCount);
            }

            //Get a socket connection information
            if(message["session"]){
               this.socketId = message["session"]["socketId"];
               this.userId = message["session"]["user"]["id"];
               this.activeUser = message["session"]["user"];
            }
            if (!this._changeDetector['destroyed']) {
                this._changeDetector.detectChanges();
            }
            this.onlineGroups = filter(this.onlineGroups, group => !group.private);
            this.allOnlineGroups = this.onlineGroups;
        });

        this.allOnlineGroups = this.onlineGroups;
  }

  /*
   * When a user click "Leave Group" it shows modal window for confirmation
   * If clicks "Join Group" call a service function to join this group
   */
  groupEvent(groupId, eleRef,name){
      var actionState = $(eleRef).attr('actionState');
      this.leavingGroupId = groupId;
      this.leavingGroupRef = eleRef;
      this.leavingGroupName= name;
      if(actionState == 'leave'){
          //Modal window open for confirmation
          (<any>$('#confirm_modal')).modal();
      }else if(actionState == 'join'){
            $('#group-'+groupId).find('button.join_grp_btn').attr("disabled", "disabled");
            //Make a action to join this group
            this._groupService.joinGroup({ groupId : groupId }).subscribe((res)=>{
                if(res){
                    if(res.success==true){

                        this.eventService.eventEmit$.next({groupReset : true});

                        $(eleRef).attr('actionState','leave');
                        $(eleRef).text('Leave Group');
                        //Increased member count value put on html element
                        $('#group-'+groupId).find('.members_count p').text(res.memCount);
                        $('#group-'+groupId).find('.groupNameTitle').addClass('activeMember');
                    }else{
                                //this.errorMsg = res.message;
                    }
                    $('#group-'+groupId).find('button.join_grp_btn').removeAttr("disabled");
                }
            });
      }


  }
/*
 * If a user click "Leave Group" from  confirmation modal window
 * Make a action to leave this group
 */
groupLeaveEvent(){
    this._groupService.leaveGroup({ groupId: this.leavingGroupId }).subscribe((res) => {
        if (res) {
            if (res.success == true) {

                this.eventService.eventEmit$.next({groupReset : true, isLeave_group: true, group_id: this.leavingGroupId});

                $(this.leavingGroupRef).attr('actionState', 'join');
                $(this.leavingGroupRef).text('Join Group');
                $('#group-' + this.leavingGroupId).find('.members_count p').text(res.memCount);
                $('#group-'+ this.leavingGroupId).find('.groupNameTitle').removeClass('activeMember');
            }
        }
    });
}
  /*
  * Reset building filter array values
  */
  resetFilterBuilding(filterBuilding){
        this.buildingsFilterGroupsLists = [];
        this.buildingsFilterGroups = [];
  }

  /*
   * Filtered group list based on user search
  */
  searchNewMsgGroup(searchGroup){
        if(!searchGroup){
            this.onlineGroups = this.allOnlineGroups;
            this.newMessageNoResult = false;
        }else{
          var eventService = this.eventService;
          this.onlineGroups = eventService.filterGroup(this.allOnlineGroups, 'firstName', searchGroup);
          if(this.onlineGroups.length === 0){
            this.newMessageNoResult = true;
          }else{
            this.newMessageNoResult = false;
          }
        }
  }

  /*
   * Called ngOnDestroy() when a user change over to other page
   * All timer subscribtion are unsubscribed()
  */

  /*
   * toggleMore is used to display view more content of the group description
  */
   toggleMore(toggleText) {
        $(toggleText).parents('.item').toggleClass('more_show');
        $(toggleText).parents('.item').find('.read_more').toggleClass('active');
        $(toggleText).parents('.item').find('.read_more img').toggle();
    }

  openGroup(group){
    if($('#group-' + group.id).find('.activeMember').length > 0){
      this.router.navigate(['groups'],{queryParams : {opengroup : group.id, name : group.name }});
    }
  }

  deleteGroup(id) {
    this._groupService.deleteGroup(id).subscribe((res) => {
        if (res) {
           console.log(res);
           this._groupService.getAllResidentsGroups()
           // this.eventService.eventEmit$.next({groupReset : true, isLeave_group: true, group_id: id});
           this.eventService.removeGroup(id);
        }
    });
  }
}
